import Vue from 'vue'

const resource = 'notices'

// お知らせの一覧を取得する
const getAll = (params = {}) => Vue.axios.get(`${resource}`, { params })

// 特定のお知らせを取得する（必要に応じて）
const getById = (id) => Vue.axios.get(`${resource}/${id}`)

// ユーザーのお知らせを既読状態に更新する
const updateReadStatus = (id, isRead) => Vue.axios.put(`${resource}/notice/${id}/read_status`, { is_read: isRead })

// その他の必要な操作があれば、ここに追加

export default {
  getAll,
  getById,
  updateReadStatus
}



// WEBPACK FOOTER //
// ./src/api/notice.js